import { Button } from "components/ui/button";
import { UserContext } from "context/userContext";
import { useContext, useEffect, useState } from "react";
import { useNavigateWithQueryParams } from "utils/navigateWithQueryParams";
import { useNavigation } from "utils/onNavigate";
import { createVerificationSession, getOrganizationConfig } from "services/api";
import config from "config";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import {
  extractRoute,
  getOrganizationFromURL,
  hexToHSL,
  LoadPageConfiguration,
  updatePrimaryColor,
} from "utils";
import {
  ALL_FLOWS,
  EQUIFAX_FLOWS,
  FLOW,
  VerificationSessionType,
  Workforce,
} from "constant";
import loginFrame from "assets/login/login-main-frame.svg";
import equifaxBanner from "assets/equifaxBanner.png";
import attBanner from "assets/attBanner.png";
import visa from "assets/visa.svg";
import Header from "common/header";
import LivenessSwitch from "../components/livenessSwitch";

let loadded = false;
const LandingPage = () => {
  const [searchParams] = useSearchParams();
  const context = useContext(UserContext);
  const {
    configuration,
    setLoginOption,
    setTokenParams,
    pageConfiguration,
    setPageIndex,
    setPageConfiguration,
    setActiveFlow,
    setPreviousRoutes,
    setIsFaceScan,
    setIsGenerateUuid,
  }: any = useContext(UserContext);
  const projectName = getOrganizationFromURL();
  const isChase = projectName === "chase";
  const [loader, setLoader] = useState(false);
  const [flow, setFlow] = useState<any>({});
  const pageConfig: any = pageConfiguration;
  const Options = flow?.flows || ALL_FLOWS;
  const logo = configuration?.logo;
  const { navigateWithQueryParams } = useNavigateWithQueryParams();
  const { navigateToNextPage } = useNavigation();
  const navigate = useNavigate();
  const [loadingState, setLoadingState] = useState("");
  useEffect(() => {
    if (projectName === "prove-v2") {
      navigateWithQueryParams("/v2/landing");
    }
  }, [projectName]);
  const onRegister = async (flow: string, redirect?: string) => {
    setLoadingState(flow);
    const payload: any = {
      ...config?.verifyConfig,
    };
    const result: any = await createVerificationSession(payload);
    setTokenParams(result?.sessionId);
    const params = `token=${result?.sessionId}${
      searchParams.get("skipAntispoof")
        ? `&skipAntispoof=${searchParams.get("skipAntispoof")}`
        : ""
    }${
      searchParams.get("spoof_attempt")
        ? `&spoof_attempt=${searchParams.get("spoof_attempt")}`
        : ""
    }${
      searchParams.get("mf_count")
        ? `&mf_count=${searchParams.get("mf_count")}`
        : ""
    }${
      searchParams.get("mf_count_signin")
        ? `&mf_count_signin=${searchParams.get("mf_count_signin")}`
        : ""
    }${
      searchParams.get("threshold")
        ? `&threshold=${searchParams.get("threshold")}`
        : ""
    }${redirect ? `&flow=${redirect}` : ''}`;
    const url = projectName === "charms" ? "/charm-landing" : "/user-consent";
    if (pageConfig) {
      setLoadingState("");
      window.location.href = `${url}?${params}`;
    } else {
      setLoadingState("");
      window.location.href = `${url}?${params}`;
    }
  };

  useEffect(() => {
    onGetOrganizationConfig(window.location.host.split(".")[0]);
  }, []);

  const onGetOrganizationConfig = async (organization?: string) => {
    setLoader(true);
    const organizationConfig: any = organization
      ? await getOrganizationConfig(organization)
      : FLOW;
    if (organizationConfig?.name) {
      const hsl = hexToHSL(organizationConfig?.primaryColor);
      updatePrimaryColor(`${hsl?.h},${hsl?.s}%,${hsl?.l}%`);
      if (organization?.includes("register-i9")) {
        context?.setConfiguration({
          ...organizationConfig,
          isUpdateUser: true,
        });
      } else {
        context?.setConfiguration({ ...organizationConfig });
      }
      if (organization) {
        const currentRouteIndex = organizationConfig?.appPages?.findIndex(
          (item: any) => item?.currentRoute === window.location.pathname
        );
        const activeIndex = currentRouteIndex;
        setPageIndex(activeIndex);
        const pageConfiguration = extractRoute(organizationConfig, activeIndex);
        setPageConfiguration(pageConfiguration);
      }
    } else {
      context?.setConfiguration({});
    }
    setLoader(false);
  };

  const onRegisterCharlie = async (flow: string) => {
    setLoadingState(flow);
    const payload: any = {
      ...config?.clientConfig,
      productGroupId:
        configuration?.productGroupId ||
        config?.clientConfig?.productGroupId ||
        "priflo",
    };
    const result: any = await createVerificationSession(payload);
    setTokenParams(result?.token?.replace("?", ""));
    const params = `token=${result?.token?.replace("?", "")}${
      searchParams.get("skipAntispoof")
        ? `&skipAntispoof=${searchParams.get("skipAntispoof")}`
        : ""
    }`;
    await onGetOrganizationConfig(flow);
    if (pageConfig) {
      setLoadingState("");
      navigateToNextPage(params, "/landing", "/");
    } else {
      setLoadingState("");
      navigate(
        `/landing?token=${result?.token?.replace("?", "")}${
          searchParams.get("skipAntispoof")
            ? `&skipAntispoof=${searchParams.get("skipAntispoof")}`
            : ""
        }`
      );
    }
  };
  const onLogin = async () => {
    setLoadingState(flow);
    const payload: any = {
      ...config?.clientConfig,
      productGroupId:
        configuration?.productGroupId ||
        config?.clientConfig?.productGroupId ||
        "priflo",
      type: VerificationSessionType.AUTH,
    };
    const result: any = await createVerificationSession(payload);
    setTokenParams(result?.token?.replace("?", ""));
    const params = `token=${result?.token?.replace("?", "")}${
      searchParams.get("skipAntispoof")
        ? `&skipAntispoof=${searchParams.get("skipAntispoof")}`
        : ""
    }`;
    if (pageConfig) {
      setLoadingState("");
      navigateToNextPage(params, "/face-login-otp", "/");
    } else {
      setLoadingState("");
      navigate(
        `/face-login-otp?token=${result?.token?.replace("?", "")}${
          searchParams.get("skipAntispoof")
            ? `&skipAntispoof=${searchParams.get("skipAntispoof")}`
            : ""
        }`
      );
    }
  };

  useEffect(() => {
    const handleBackButton = () => {
      LoadPageConfiguration(context, "/");
    };
    window.addEventListener("popstate", handleBackButton);
    return () => {
      window.removeEventListener("afterprint", handleBackButton);
    };
  }, []);

  const onContinuousAuth = async () => {
    localStorage.removeItem("isPinScreen");
    setLoadingState(flow);
    const payload: any = {
      ...config?.clientConfig,
      productGroupId:
        configuration?.productGroupId ||
        config?.clientConfig?.productGroupId ||
        "priflo",
      type: VerificationSessionType.AUTH,
    };
    const result: any = await createVerificationSession(payload);
    setTokenParams(result?.token?.replace("?", ""));
    const params = `token=${result?.token?.replace("?", "")}${
      searchParams.get("skipAntispoof")
        ? `&skipAntispoof=${searchParams.get("skipAntispoof")}`
        : ""
    }`;
    if (pageConfig) {
      setLoadingState("");
      navigateToNextPage(params, "/continuous-authentication-v2", "/");
    } else {
      setLoadingState("");
      navigate(
        `/continuous-authentication-v2?token=${result?.token?.replace(
          "?",
          ""
        )}${
          searchParams.get("skipAntispoof")
            ? `&skipAntispoof=${searchParams.get("skipAntispoof")}`
            : ""
        }`
      );
    }
  };

  const onLoginWithMobile = async (flow: string) => {
    setLoadingState(flow);
    const payload: any = {
      ...config?.clientConfig,
      productGroupId:
        configuration?.productGroupId ||
        config?.clientConfig?.productGroupId ||
        "priflo",
    };
    const result: any = await createVerificationSession(payload);
    setTokenParams(result?.token?.replace("?", ""));
    const params = `token=${result?.token?.replace("?", "")}${
      searchParams.get("skipAntispoof")
        ? `&skipAntispoof=${searchParams.get("skipAntispoof")}`
        : ""
    }${
      searchParams.get("spoof_attempt")
        ? `&spoof_attempt=${searchParams.get("spoof_attempt")}`
        : ""
    }${
      searchParams.get("mf_count")
        ? `&mf_count=${searchParams.get("mf_count")}`
        : ""
    }${
      searchParams.get("mf_count_signin")
        ? `&mf_count_signin=${searchParams.get("mf_count_signin")}`
        : ""
    }`;
    const url = "/v2/user-info-sms";
    if (pageConfig) {
      setLoadingState("");
      navigateToNextPage('', `${url}`, "/");
    } else {
      setLoadingState("");
      navigateToNextPage('', `${url}`, "/");
    }
  };
  const onFaceLogin = async (url: string, flow?:string,  isNewUi?: boolean) => {
    const payload: any = {
      ...config?.verifyConfig,
    };
    const result: any = await createVerificationSession(payload);
    setTokenParams(result?.sessionId);
    const params = `token=${result?.sessionId}${searchParams.get("skipAntispoof")
      ? `&skipAntispoof=${searchParams.get("skipAntispoof")}`
      : ""
      }${searchParams.get("spoof_attempt")
        ? `&spoof_attempt=${searchParams.get("spoof_attempt")}`
        : ""
      }${searchParams.get("mf_count")
        ? `&mf_count=${searchParams.get("mf_count")}`
        : ""
      }${searchParams.get("mf_count_signin")
        ? `&mf_count_signin=${searchParams.get("mf_count_signin")}`
        : ""
      }${searchParams.get("threshold")
        ? `&threshold=${searchParams.get("threshold")}`
        : ""
      }${flow ? `&flow=${flow}` : ''}`;
      window.location.href = `${url}?${params}`;
  }
  const onContinue = (flow: string) => {
    if (flow === "register") {
      setIsGenerateUuid(false);
      onRegister(flow);
      return;
    } else if (flow === "register-face") {
      setIsGenerateUuid(false);
      setIsFaceScan(true);
      onRegister(flow, 'register-face');
      return;
    } else if (flow === "generate-uuid") {
      setIsGenerateUuid(true);
      navigateToNextPage("", "/user-consent", "/");
      return;
    } else if (["register-i9", "fox-i9"]?.includes(flow)) {
      setIsGenerateUuid(false);
      onRegisterCharlie(flow);
      return;
    } else if (flow === "face-login-mobile") {
      setIsGenerateUuid(false);
      navigateToNextPage("", "/login-mobile", "/");
      return;
    } else if (flow === "face-login-mobile-otp") {
      setIsGenerateUuid(false);
      navigateToNextPage("", "/login-mobile", "/");
      return;
    } else if (flow === "multi-frame-login") {
      setIsGenerateUuid(false);
      setLoadingState(flow);
      onFaceLogin('/multi-frame-login', flow);
      return;
    } else if (flow === "face-register-mobile") {
      setIsGenerateUuid(false);
      navigateToNextPage("", "/register-mobile", "/");
      return;
    } else if (flow === "face-register-mobile-with-id") {
      setIsGenerateUuid(false);
      navigateToNextPage("", "/register-mobile-with-id", "/");
      return;
    } else if (flow === "register-mobile-with-passport") {
      setIsGenerateUuid(false);
      navigateToNextPage("", "/register-mobile-with-passport", "/");
      return;
    } else if (flow === "checkoutVc") {
      setIsGenerateUuid(false);
      setLoadingState(flow);
      onFaceLogin('/checkout', flow);
    } else if (flow === "face-login-otp") {
      setIsGenerateUuid(false);
      onLogin();
    } else if (flow === "continuous_authentication") {
      setIsGenerateUuid(false);
      if (projectName === "charlie") {
        onContinuousAuth();
      } else {
        navigateWithQueryParams("/continuous-authentication");
      }
    } else if (["predictAge", "predictAge-Dl"]?.includes(flow)) {
      context.setUser("");
      setIsGenerateUuid(false);
      setLoadingState(flow);
      window.location.href = configuration?.redirectUrl || "https://priflo-age.privateidentity.com"
    } else if (flow === "prove-register") {
      setIsGenerateUuid(false);
      navigateToNextPage("", '/v2/consent', '/');
    } else if (flow === "prove-login") {
      setIsGenerateUuid(false);
      setLoadingState(flow);
      onFaceLogin('/login-v2', flow, true);
    } else if (flow === "prove-reset") {
      setIsGenerateUuid(false);
      setLoginOption(flow);
      setLoadingState(flow);
      onFaceLogin('/login-v2', flow);
    } else if (flow === "prove-checkout") {
      setIsGenerateUuid(false);
      setLoginOption(flow);
      navigateToNextPage("", "/v2/checkout", "/");
    } else if (flow === "login-with-magic-link") {
      setIsGenerateUuid(false);
      setLoginOption(flow);
      onLoginWithMobile(flow);
    } else if (flow === "prove-register-face") {
      setIsGenerateUuid(true);
      setLoginOption(flow);
      navigateToNextPage();
    } else {
      setIsGenerateUuid(false);
      setLoginOption(flow);
      setLoadingState(flow);
      onFaceLogin('/face-login', flow);
    }
  };

  useEffect(() => {
    if (projectName === "charms") {
      onContinue("register");
    }
  }, [projectName]);

  const renderBannerImage = () => {
    switch (projectName) {
      case "att":
        return attBanner;
      case "equal":
        return equifaxBanner;
      case "cache":
        return visa;
      default:
        return configuration?.bannerImage || loginFrame;
    }
  };

  const loadPageConfiguration = () => {
    const currentRouteIndex = configuration?.appPages?.findIndex(
      (item: any) => item?.currentRoute === window.location.pathname
    );
    const activeIndex = currentRouteIndex;
    setPageIndex(activeIndex);
    const pageConfiguration = extractRoute(configuration, activeIndex);
    setPageConfiguration(pageConfiguration);
  };

  useEffect(() => {
    if (!loadded) {
      loadded = true;
      loadPageConfiguration();
    }
  }, [configuration, loadded]);

  const onChangeFlow = (value: string) => {
    setActiveFlow(value);
    setPreviousRoutes([]);
    localStorage.setItem("equifaxActiveFlow", value);
    const options = pageConfig?.options || ALL_FLOWS;
    const flows = options?.filter((flow: any) => flow?.type === value);
    const bannerHeading = value === EQUIFAX_FLOWS[1] ? "Verified Consumer" : "";
    setFlow({
      flows: flows?.length > 0 ? flows : Workforce,
      bannerHeading,
    });
  };
  useEffect(() => {
    onChangeFlow(localStorage.getItem("equifaxActiveFlow") || EQUIFAX_FLOWS[0]);
  }, [pageConfig]);

  if (loader) {
    return (
      <div className="absolute h-full w-full left-0 top-0 z-50 flex items-center justify-center">
        <Loader2 className="animate-spin h-[55px] w-[55px] text-[#000]" />
      </div>
    );
  }

  if (projectName === "charms") return null;
  return (
    <div
      className={`bg-[url('https://equifax.privateid.co/static/media/equifaxBG.3d8cdb8d8f05eff93313dc72c275c6c3.svg')] bg-[100% 100%] bg-center bg-no-repeat ${
        configuration?.bgColor ? "h-[100vh] max-md:h-[calc(100vh_0px)]" : ""
      }`}
      style={{ backgroundColor: configuration?.bgColor }}
    >
      {/* Header */}
      <Header onChangeFlow={onChangeFlow} />
      {/* Header End */}
      {/* Banner */}
      <div className="flex h-[80vh] items-center container max-md:p-[10px]">
        {/* Left wrap */}
        <div className="flex-1">
          <div className="w-[400px] max-md:w-[100%] max-md:mt-[2rem]">
            {!isChase && (
              <img
                src={logo}
                alt=""
                data-src={logo}
                className={`lazyload ${
                  configuration?.bannerWidth
                    ? `w-[${configuration?.bannerWidth}]`
                    : "w-[150px]"
                }  m-auto`}
              />
            )}
            <p
              className={`text-[24px] mb-[5px] text-[#837d7d] text-center ${
                (isChase || configuration?.isKantara) && "text-center"
              }`}
            >
              {flow?.bannerHeading ||
                pageConfig?.title ||
                "Verified Private Identity"}
            </p>
            {configuration?.isKantara && (
              <p className="mt-[-5px] text-[18px] mb-[20px] text-center font-[400] text-secondaryText max-md:text-[14px] max-md:w-[80%] max-md:m-auto max-md:mt-[7px]">
                A simple, fast and safe way to verify yourself.
              </p>
            )}
            <div>
              {Options?.map(
                (
                  item: { title: string; value: string; enable: boolean },
                  index: number
                ) => {
                  if (!item?.enable) return null;
                  return (
                    <Button
                      key={index}
                      className="w-[100%] justify-start h-[70px] bg-primary font-[400] rounded-[10px] text-[20px] hover:opacity-90 hover:bg-primary text-white max-md:w-[100%] mb-[10px] hover:underline"
                      onClick={() => onContinue(item?.value)}
                    >
                      {loadingState === item?.value ? (
                        <Loader2 className="animate-spin h-[55px] w-[55px] text-[#fff] m-auto" />
                      ) : (
                        item?.title
                      )}
                    </Button>
                  );
                }
              )}
            </div>
          </div>
        </div>
        {/* Left wrap end */}
        {/* Right wrap */}
        <div className="flex-1 flex justify-center max-md:hidden">
          <div className="w-[500px]">
            <img
              src={renderBannerImage()}
              alt=""
              data-src={renderBannerImage()}
              className={`lazyload w-[80%] m-auto`}
            />
          </div>
        </div>
        {/* Right wrap */}
      </div>
      {/* Banner end */}
      <LivenessSwitch
        liveness={configuration?.liveness}
        show={configuration?.livenessSwitch}
      />
    </div>
  );
};

export default LandingPage;
